import axiosInstance from "../../setupAxios";
import { IDraftWorkSearchQuery } from "../types/IDraftWorkSearchQuery";
import { IRegisteredWorkSearchQuery } from "../types/IRegisteredWorkSearchQuery";
import { IDraftWorkSearchResult } from "../types/IDraftWorkSearchResult";
import { IRegisteredWorkSearchResult } from "../types/IRegisteredWorkSearchResult";
import { IArtistSearchQuery } from "../../repertoire/types/IArtistSearchQuery";
import { IArtist } from "../../repertoire/types/IArtist";
import { IAllRegisteredWorkSearchResult } from "../types/IAllRegisteredWorkSearchResult";
import { IAllRegisteredWorkSearchQuery } from "../types/IAllRegisteredWorkSearchQuery";
import { IMemberStatementSearchQuery } from "../types/IMemberStatementSearchQuery";
import { IMemberStatementSearchResult } from "../types/IMemberStatementSearchResult";
import { IDraftSetListSearchResult } from "../types/IDraftSetListSearchResult";
import { IDraftSetListSearchQuery } from "../types/IDraftSetListSearchQuery";
import { IMatchWorksSearchQuery } from "../../repertoire/types/usageTypes/IMatchWorksSearchQuery";
import { IMatchWorksSearchResult } from "../../repertoire/types/usageTypes/IMatchWorksSearchResult";
import { INTRAY } from "../Consts";
import { ILivePerformanceSearchQuery } from "../types/ILivePerformanceSearchQuery";
import { ILivePerformancesSearchResult } from "../types/ILivePerformancesSearchResult";
import {IUnpaidClaimsSearchQuery } from "../types/IUnpaidClaimsSearchQuery";
import { IClaimUnidentifiedClaimModal } from "../types/IClaimUnidentifiedClaimModal";
import { IUnpaidClaimsSearchResult } from "../types/IUnpaidClaimsSearchResult";
import { IClaimsHistorySearchQuery, IClaimsHistorySearchResult } from "../types/IClaimsHistorySearchQuery";
import { IDraftAgreementSearchQuery } from "../types/IDraftAgreementSearchQuery";
import { IDraftAgreementSearchResult } from "../types/IDraftAgreementsSearchResult";
import { IRegisteredAgreementSearchResult } from "../types/IRegisteredAgreementSearchResult";
import { IRegisteredAgreementSearchQuery } from "../types/IRegisteredAgreementSearchQuery";
import { IIPsSearchQuery } from "../../repertoire/types/IIPsSearchQuery";
import { IIPsSearchResult } from "../../repertoire/types/IIPsSearchResult";
import { IWorksSearchQuery } from "../../repertoire/types/IWorksSearchQuery";
import { IWorksSearchResult } from "../../repertoire/types/IWorksSearchResult";
import { ILookupDictionary } from "../../lookup/types/ILookupDictionary";
import { AGREEMENT_CATEGORY_LOOKUP, AGREEMENT_STATUS_LOOKUP, WORK_STATUS_LOOKUP } from "../../lookup/Consts";
import { ICueSheetsSearchQuery } from "../types/ICueSheetsSearchQuery";
import { ICueSheetsSearchResult } from "../types/ICueSheetsSearchResult";
import { IFileSystem } from "../../dataingestion/types/IFileSystem";
import { ILicenseVenueSearchQuery } from "../../repertoire/types/ILicenseVenueSearchQuery";
import { ILicenseCustomerVenue } from "../../repertoire/types/ILicenseCustomerVenue";
import { IAgreementWork } from "../../repertoire/types/IAgreementWork";
import { IApplicableWorkSearchQuery } from "../../repertoire/types/IApplicableWorkSearchQuery";
import { isValidNumber } from "../../util/tools";

export class SearchRequests {
    public static getConfigurationParameter(key: string, group: string): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            axiosInstance
                .get("/Component/ConfigurationParameter/" + key + "/" + group)
                .then(response => {
                    if (response.status === 200) {
                        const result = response.data;
                        resolve(result);
                    }
                    else {
                        throw response;
                    }
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    public static getLivePerformancesDistribution(): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            axiosInstance
                .get("/MembersPortalLivePerformance/GetDistribution/")
                .then(response => {
                    if (response.status === 200) {
                        const result = response.data;
                        resolve(result);
                    }
                    else {
                        throw response;
                    }
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    public static getStorageBlobs(path: string, isRepertoireModule?: boolean, iPNameNumber?: string): Promise<any> {
        return new Promise<IFileSystem[]>((resolve, reject) => {
            axiosInstance.post(encodeURI(`Storage/Blobs`), { path: path, IsRepertoireModule: isRepertoireModule, iPNameNumber: iPNameNumber })
                .then(response => {
                    if (response.status === 200) {
                        resolve(response.data);
                    }
                    else {
                        throw response;
                    }
                })
                .catch(err => {
                    reject(err);
                });
        });
    }
   public static getLicenseVenues(
        licenseVenue: ILicenseVenueSearchQuery,
        dataSource: string
    ): Promise<ILicenseCustomerVenue[]> {
        return new Promise<ILicenseCustomerVenue[]>((resolve, reject) => {
            axiosInstance
                .post("/License/LicensingVenue", {
                    code: licenseVenue.code,
                    name: licenseVenue.name,
                })
                .then(response => {
                    const licenseVenueSearchResultItems: ILicenseCustomerVenue[] = [];

                    for (let x = 0; x < response.data.length; x++) {
                        const data = response.data[x];

                        const licenseVenueSearchResultItem: ILicenseCustomerVenue = {
                            customerID: data.customerID,
                            venueCode: data.code,
                            venueName: data.name,
                            city: data.city,
                            region: data.region,
                            country: data.country,
                            mapLink: data.mapLink,
                            contactEmail: data.contactEmail,
                            contactFirstName: data.contactFirstName,
                            contactLastName: data.contactLastName,
                            venueType: data.usageGroupVenueTypeID,
                            contactPhoneNumber: data.contactPhoneNumber,
                            createdDate: data.createdDate,
                        };
                        licenseVenueSearchResultItems.push(licenseVenueSearchResultItem);
                    }
                    resolve(licenseVenueSearchResultItems);
                })
                .catch(res => {
                    reject(res);
                });
        });
    }
    public static async getCueSheetsBlobs(path: string, iPNameNumber: string): Promise<any> {
        try {
            const response = await axiosInstance.post<IFileSystem[]>(
                encodeURI(`Storage/CueSheetsBlobs`),
                { path, iPNameNumber }
            );

            if (response.status === 200) {
                return response.data;
            }

            throw response;
        } catch (error) {
            return Promise.reject(error);
        }
    }

    public static getDraftWorkHistoryVersion(DraftWorkID: number, versionNumber: number): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            axiosInstance
                .get("/DraftWork/DraftWorkHistory/" + DraftWorkID + '/' + versionNumber)
                .then(response => {
                    if (response.status === 200) {
                        const result = response.data;
                        resolve(result);
                    }
                    else {
                        throw response;
                    }
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    public static getMemberStatements(searchQuery: IMemberStatementSearchQuery): Promise<IMemberStatementSearchResult[]> {
        const {
            viewStatementsFrom,
            customRange,
            dateFrom,
            dateTo,
            paymentID,
            distributionCode,
            pool,
            workNumber,
            currentUserNameNumber
        } = searchQuery

        return new Promise<IMemberStatementSearchResult[]>((resolve, reject) => {
            axiosInstance
                .post("/Search/MemberStatements", {
                    viewStatementsFrom: viewStatementsFrom,
                    customRange: customRange,
                    dateFrom: dateFrom,
                    dateTo: dateTo,
                    paymentID: paymentID,
                    distributionCode: distributionCode,
                    pool: pool,
                    workNumber: workNumber,
                    currentUserNameNumber: currentUserNameNumber
                })
                .then(response => {
                    resolve(response.data);
                })
                .catch(response => {
                    reject(response.message);
                })
        });
    }

    public static claimUnpaidUsage(query: IClaimUnidentifiedClaimModal) {
        const {
            usageGroupId,
            claimedWorkId,
            claimantCurrentUserNameNumber,
        } = query 
        return new Promise<IUnpaidClaimsSearchResult[]>((resolve, reject) => {
        axiosInstance
        .post("/MembersPortalClaim/ClaimUP", {
                    UsageGroupId: usageGroupId,
                    ClaimedWorkId: `${claimedWorkId}`,
                    ClaimantCurrentUserNameNumber: claimantCurrentUserNameNumber,
                })
                .then(response => {
                    resolve(response.data);
                })
                .catch(response => {
                    reject(response.message);
                })
            });
    }

    public static getUnpaidClaims(searchQuery: IUnpaidClaimsSearchQuery, continuationToken: string): Promise<IUnpaidClaimsSearchResult[]> {
        const {
            fullTitle,
            fullContributor,
            fullPerformer,
            sourceMinor,
            sourceMajor,
            workNumber,
            distributionCode,
            isMembersPortal,
            performanceFromDate,
            performanceToDate
        } = searchQuery

        return new Promise<IUnpaidClaimsSearchResult[]>((resolve, reject) => {
            axiosInstance
                .post("/MembersPortalSearch/UnpaidUsages", {
                    fullTitle: {
                        value: fullTitle,
                        type: 0
                    },
                    fullContributor: {
                        value: fullContributor,
                        type: 0
                    },
                    performanceFromDate: {
                        value: performanceFromDate,
                        type: 0
                    },
                    performanceToDate: {
                        value: performanceToDate,
                        type: 0
                    },
                    fullPerformer: {
                        value: fullPerformer,
                        type: 0
                    },
                    sourceMinor: {
                        value: sourceMinor,
                        type: 0
                    },
                    sourceMajor: {
                        value: sourceMajor,
                        type: 0
                    },
                    workNumber: {
                        value: workNumber,
                        type: 0
                    },
                    distributionCode: {
                        value: distributionCode,
                        type: 0
                    },
                }
                    )
                .then(response => {
                    resolve(response.data);
                })
                .catch(response => {
                    reject(response.message);
                })
        });
    }

    public static getClaimsHistory(searchQuery: IClaimsHistorySearchQuery, continuationToken: string): Promise<IClaimsHistorySearchResult[]> {
        const {
            fullTitle,
            claimApprovalStatus,
            isMembersPortal,
            claimantCurrentUserNameNumber,
        } = searchQuery

        return new Promise<IUnpaidClaimsSearchResult[]>((resolve, reject) => {
            axiosInstance
                .post("/MembersPortalSearch/MemberClaimHistory", {
                    fullTitle: {
                        value: fullTitle,
                        type: 0
                    },
                    claimStatus: {
                        value: claimApprovalStatus,
                        type: 0
                    },
                    claimantCurrentUserNameNumber: {
                        value: claimantCurrentUserNameNumber,
                        type: 0
                    }
                }
                    )
                .then(response => {
                    resolve(response.data);
                })
                .catch(response => {
                    reject(response.message);
                })
        });
    }

    public static async getCueSheets(
        searchQuery: ICueSheetsSearchQuery,
        getAllCueSheets: boolean,
        searchMethod: string
    ): Promise<ICueSheetsSearchResult[]> {
        try {
            const {
                cueSheetID,
                title,
                status,
                dataSource,
                productionType,
                currentUserNameNumber,
                includeCueSheetsWithMyRegisteredWorks
            } = searchQuery;

            const response = await axiosInstance.post(`/Search/${searchMethod}`, {
                productId: cueSheetID,
                title,
                status: status,
                dataSource,
                productionType,
                currentUserNameNumber: getAllCueSheets ? null : currentUserNameNumber,
                includeCueSheetsWithMyRegisteredWorks
            });

            return this.mapProductResults<ICueSheetsSearchResult>(
                response.data,
                item => this.mapToProductResult(item, dataSource)
            );

        } catch (error: any) {
            throw new Error(error.message || 'Failed to fetch cue sheets.');
        }
    }

    //TODO: this can be used by getSetLists
    public static mapProductResults<T>(
        data: any[],
        mapFn: (item: any) => T
    ): T[] {
        return data.map(mapFn);
    }

    private static mapToProductResult(
        item: any,
        dataSource: string
    ): any {
        const titles = (item.productNames || []).slice(0, 3).map(n => n.name);
        const artists = (item.productPerformers || []).slice(0, 3).map((n: any) => n.performerName);
        const numbers = (item.productNumbers || []).slice(0, 3).map((n: any) => n.number);
        const contributors = (item.productContributors || []).slice(0, 3).map((n: any) => n.name);


        return {
            productCoreID: item.productCoreID,
            dataSource,
            type: item.productType,
            id1: item.id1,
            id2: item.id2 || '',
            cueSheetID: item.id1,
            setListID: '',
            productStatus: item.status,
            number: numbers,
            title: titles,
            source: item.source,
            artist: artists,
            contributor: contributors,
            dateCreated: item.dateCreated
        };
    }

    public static getSetLists(searchQuery: IDraftSetListSearchQuery, searchMethod: string): Promise<IDraftSetListSearchResult[]> {
        const {
            setListID,
            title,
            status,
            dataSource,
            currentUserNameNumber
        } = searchQuery;

        return new Promise<IDraftSetListSearchResult[]>((resolve, reject) => {
            axiosInstance
                .post(`/Search/${searchMethod}`, {
                    productId: setListID,
                    title: title,
                    status: status,
                    dataSource: dataSource,
                    currentUserNameNumber: currentUserNameNumber
                })
                .then(response => {
                    const productSearchResultItems: IDraftSetListSearchResult[] = [];
                    for (let x = 0; x < response.data.length; x++) {
                        const data = response.data[x];

                        let productSearchResultItem: IDraftSetListSearchResult = {
                            productCoreID: response.data[x].productCoreID,
                            dataSource: dataSource,
                            type: response.data[x].productType,
                            id1: response.data[x].id1,
                            id2: response.data[x].id2 ? response.data[x].id2 : '',
                            setListID: response.data[x].id1,
                            productStatus: response.data[x].status,
                            number: [],
                            title: [],
                            source: response.data[x].source,
                            artist: [],
                            contributor: [],
                            dateCreated: response.data[x].dateCreated
                        }

                        for (let x = 0; x < 3; x++) {
                            if (data.productNames[x]) {
                                productSearchResultItem.title.push(data.productNames[x].name)
                            }

                            if (data.productPerformers[x]) {
                                productSearchResultItem.artist.push(data.productPerformers[x].performerName)
                            }

                            if (data.productNumbers[x]) {
                                productSearchResultItem.number.push(data.productNumbers[x].number)
                            }

                            if (data.productContributors[x]) {
                                productSearchResultItem.contributor.push(data.productContributors[x].name)
                            }
                        }
                        if (!productSearchResultItem.productStatus || productSearchResultItem.productStatus === null) {
                            productSearchResultItem.productStatus = 'DRAFT';
                        }
                        if (dataSource === INTRAY)
                            productSearchResultItem.productStatus = productSearchResultItem.productStatus === 'DRAFT' ? 'Draft' : 'Draft Submitted';
                        else
                            productSearchResultItem.productStatus = 'Registered';

                        productSearchResultItems.push(productSearchResultItem);
                    }
                    resolve(productSearchResultItems);
                })
                .catch(response => {
                    reject(response.message);
                })
        });
    }

    public static getDraftAgreements(
        searchQuery: IDraftAgreementSearchQuery,
        lookupValues: ILookupDictionary
    ): Promise<IDraftAgreementSearchResult[]> {
        const {
            category,
            type,
            ipNumber,
            ipName,
            number,
            searchType,
            currentUserNameNumber,
        } = searchQuery;

        return new Promise<IDraftAgreementSearchResult[]>((resolve, reject) => {
            axiosInstance
                .post("/Search/DraftAgreements", {
                    agreementCategory: category,
                    type: type,
                    number: number === '' || number === "'" ? null : number,
                    ipNameNumber: ipNumber,
                    ipName: ipName,
                    searchType,
                    currentUserNameNumber: currentUserNameNumber
                })
                .then(response => {
                    let categoryLookup = lookupValues[AGREEMENT_CATEGORY_LOOKUP].lookups;
                    let statusLookup = lookupValues[AGREEMENT_STATUS_LOOKUP].lookups;
                    let typeLookup = lookupValues['AgreementType'].lookups;
                    response.data = response.data.filter(item => item.agreementCategory === 'ADM' || item.agreementCategory === 'SPB' || item.agreementCategory === 'SPG');
                    for (let x = 0; x < response.data.length; x++) {
                        response.data[x].agreementCategory = categoryLookup.filter(l => l.code === response.data[x].agreementCategory).length > 0 ? categoryLookup.filter(l => l.code === response.data[x].agreementCategory)[0].description : '';
                        response.data[x].agreementType = typeLookup.filter(l => l.code === response.data[x].type).length > 0 ? typeLookup.filter(l => l.code === response.data[x].type)[0].description : '';
                        response.data[x].agreementStatus = statusLookup.filter(l => l.code === response.data[x].agreementStatus).length > 0 ? statusLookup.filter(l => l.code === response.data[x].agreementStatus)[0].description : '';
                    }
                    resolve(response.data);
                })
                .catch(response => {
                    reject(response.message);
                })
        });
    }

    public static getDraftAgreementsIp(
        searchQuery: IIPsSearchQuery
    ): Promise<IIPsSearchResult[]> {
        const {
            ipNumber,
            fullName,
            accountNumber,
            interestedPartyType,
            count,
            skip
        } = searchQuery;
        return new Promise<IIPsSearchResult[]>((resolve, reject) => {
            axiosInstance
                .post("/Search/DraftAgreementsIPs", {
                    ipiNumber: {
                        value: ipNumber && !isNaN(Number(ipNumber)) ? ipNumber : null,
                        type: 0
                    },
                    fullName: {
                        value: fullName,
                        type: 0
                    },
                    ipBaseNumber: {
                        value: ipNumber && !isNaN(Number(ipNumber)) ? "" : ipNumber,
                        type: 0
                    },
                    accountNumber: {
                        value: accountNumber,
                        type: 1
                    },
                    replacedAccounts: [{
                        fieldName: "ReplacedAccount",
                        filterFields: [{
                            fieldName: "Number",
                            values: {
                                value: accountNumber,
                                type: 3
                            }
                        }]
                    }],
                    interestedPartyType: interestedPartyType,
                    pagination: {
                      count: count,
                      skip: skip
                    }
                })
                .then(response => {
                    const ipSearchResultItems = [];

                    for (let x = 0; x < response.data.length; x++) {
                        const ipSearchResultItem = {
                            ipiNumber: response.data[x].ipiNumber,
                            ipBaseNumber: response.data[x].ipBaseNumber,
                            ipName: response.data[x].fullName,
                            type: response.data[x].type,
                            accountNumber: response.data[x].accountNumber,
                            societyAffiliation: response.data[x].societyAffiliation,
                            legalEntityType: response.data[x].legalEntityType,
                            accountName:response.data[x].accountName,
                            birthDate: response.data[x].birthDate !== null ? response.data[x].birthDate.substring(0, 10) : null,
                            isLibraryPublisher: response.data[x].isLibraryPublisher !== null ? response.data[x].isLibraryPublisher : null
                        };

                        ipSearchResultItems.push(ipSearchResultItem);
                    }
                    resolve(ipSearchResultItems);
                })
                .catch(res => {
                    reject(res);
                });
        })
    }

    public static getDraftAgreementWorks(
        searchQuery: IWorksSearchQuery
    ): Promise<IWorksSearchResult[]> {
        const {
            title,
            number,
            artist,
            writers,
            societyAccountNumber,
            dataSource,
            workBatchID,
            hasOpenWorkflow,
            workType,
            workGroupID
        } = searchQuery;

        return new Promise<IWorksSearchResult[]>((resolve, reject) => {
            axiosInstance
                .post("/Search/DraftAgreementsWorks", {
                    title: {
                        value: title,
                        type: 0
                    },
                    number: {
                        value: number,
                        type: 0
                    },
                    artist: {
                        value: artist,
                        type: 0
                    },
                    contributor: {
                        value: writers,
                        type: 0
                    },
                    societyAccountNumber: {
                        value: societyAccountNumber,
                        type: 0
                    },
                    workBatchID: {
                        value: workBatchID,
                        type: 2
                    },
                    dataSource: dataSource,
                    workType: {
                        value: workType,
                        type: 2
                    },
                    hasOpenWorkflow: {
                        value: hasOpenWorkflow,
                        type: 2
                    },
                    workGroupID: {
                        value: workGroupID,
                        type: 0
                    }
                })
                .then(response => {
                    const workSearchResultItems: IWorksSearchResult[] = [];

                    for (let x = 0; x < response.data.length; x++) {
                        const data = response.data[x];

                        let workSearchResultItem: IWorksSearchResult = {
                            title: [],
                            number: [],
                            isReplaced: data.isReplaced ? data.isReplaced : false,
                            writers: [],
                            publishers: [],
                            artists: [],
                            compoundType: data.medleyType ? data.medleyType : '',
                            workID: response.data[x].workID,
                            dataSource: dataSource,
                            duration: data.duration
                        }

                        for (let x = 0; x < 3; x++) {
                            if (data.workNames[x]) {
                                workSearchResultItem.title.push(data.workNames[x].name)
                            }

                            if (data.workNumbers[x]) {
                                workSearchResultItem.number.push(data.workNumbers[x].number)
                            }

                            if (data.performers[x]) {
                                workSearchResultItem.artists.push(data.performers[x].fullName)
                            }
                        }

                        if (data.contributors) {
                            for (let x = 0; x < data.contributors.length; x++) {
                                if (data.contributors[x].contributorType === 'Writer' && workSearchResultItem.writers.length < 3) {
                                    workSearchResultItem.writers.push(data.contributors[x].fullName)
                                }
                                if (data.contributors[x].contributorType === 'Publisher' && workSearchResultItem.publishers.length < 3) {
                                    workSearchResultItem.publishers.push(data.contributors[x].fullName)
                                }
                            }
                        }

                        workSearchResultItems.push(workSearchResultItem);
                    }

                    resolve(workSearchResultItems);
                })
                .catch(res => {
                    reject(res);
                });
        });
    }

    public static getRegisteredAgreements(
        searchQuery: IRegisteredAgreementSearchQuery,
        lookupValues: ILookupDictionary
    ): Promise<IRegisteredAgreementSearchResult[]> {
        const {
            category,
            type,
            ipNumber,
            ipName,
            number,
            searchType,
            currentUserNameNumber,
        } = searchQuery;

        return new Promise<IRegisteredAgreementSearchResult[]>((resolve, reject) => {
            axiosInstance
                .post("/Search/RegisteredAgreements", {
                    agreementCategory: category,
                    type: type,
                    number: number === '' || number === "'" ? null : number,
                    ipNameNumber: ipNumber,
                    ipName: ipName,
                    searchType,
                    currentUserNameNumber: currentUserNameNumber
                })
                .then(response => {
                    let categoryLookup = lookupValues[AGREEMENT_CATEGORY_LOOKUP].lookups;
                    let statusLookup = lookupValues[AGREEMENT_STATUS_LOOKUP].lookups;
                    let typeLookup = lookupValues['AgreementType'].lookups;
                    response.data = response.data.filter(item => item.agreementCategory === 'ADM' || item.agreementCategory === 'SPB' || item.agreementCategory === 'SPG');
                    for (let x = 0; x < response.data.length; x++) {
                        response.data[x].agreementCategory = categoryLookup.filter(l => l.code === response.data[x].agreementCategory).length > 0 ? categoryLookup.filter(l => l.code === response.data[x].agreementCategory)[0].description : '';
                        response.data[x].agreementType = typeLookup.filter(l => l.code === response.data[x].type).length > 0 ? typeLookup.filter(l => l.code === response.data[x].type)[0].description : '';
                        response.data[x].agreementStatus = statusLookup.filter(l => l.code === response.data[x].agreementStatus).length > 0 ? statusLookup.filter(l => l.code === response.data[x].agreementStatus)[0].description : '';
                    }
                    resolve(response.data);
                })
                .catch(response => {
                    reject(response.message);
                })
        });
    }

    public static getDraftWorks(searchQuery: IDraftWorkSearchQuery): Promise<IDraftWorkSearchResult[]> {
        const {
            title,
            status,
            workNumber,
            artist,
            ipNumber,
            ipName,
            dataSource,
            currentUserNameNumber
        } = searchQuery;

        return new Promise<IDraftWorkSearchResult[]>((resolve, reject) => {
            axiosInstance
                .post("/Search/DraftWorks", {
                    title: title,
                    status: status,
                    workNumber: workNumber,
                    artist: artist,
                    ipNumber: ipNumber,
                    ipName: ipName,
                    dataSource: dataSource,
                    currentUserNameNumber: currentUserNameNumber
                })
                .then(response => {
                    const draftWorkSearchResultItems: IDraftWorkSearchResult[] = [];
                    for (let x = 0; x < response.data.length; x++) {
                        const work = response.data[x];
                        const workCode = response.data[x].workTerritorySpecificInfo?.[0]?.workStatus ?? "-";

                        let workSearchResultItem: IDraftWorkSearchResult = {
                            workID: response.data[x].workID,
                            dataSource: response.data[x].dataSource,
                            title: [],
                            status: workCode,
                            workNumber: [],
                            workContributorIDs: [],
                            contributors: [],
                            ipNumber: [],
                            role: [],
                            perfShare: [],
                            mechShare: [],
                            performers: [],
                            duration: response.data[x].duration,
                        }

                        for (let j = 0; j < 3; j++) {
                            if (work.workNames[j]) {
                                workSearchResultItem.title.push(work.workNames[j].name);
                            }

                            if (work.workNumbers[j]) {
                                workSearchResultItem.workNumber.push(work.workNumbers[j].number);
                            }

                            if (work.performers[j]) {
                                workSearchResultItem.performers.push(work.performers[j].fullName);
                            }
                        }

                        if (work.contributors) {
                            for (let j = 0; j < work.contributors.length; j++) {
                                if (work.contributors[j].workContributorID != null) { workSearchResultItem.workContributorIDs.push(work.contributors[j].workContributorID); }
                                else { workSearchResultItem.workContributorIDs.push(0); }

                                if (work.contributors[j].fullName != null && work.contributors[j].fullName != ' ') { workSearchResultItem.contributors.push(work.contributors[j].fullName); }
                                else { workSearchResultItem.contributors.push('unknown'); }

                                if (work.contributors[j].type != null) { workSearchResultItem.role.push(work.contributors[j].type); }
                                else { workSearchResultItem.role.push('X'); }
                                
                                if (work.contributors[j].ipiNumber != null) { workSearchResultItem.ipNumber.push(work.contributors[j].ipiNumber); }
                                else { workSearchResultItem.ipNumber.push(0) }
                                
                                if (work.contributors[j].performingShare != null) { workSearchResultItem.perfShare.push(work.contributors[j].performingShare); }
                                else workSearchResultItem.perfShare.push(0);
                                
                                if (work.contributors[j].mechanicalShare != null) { workSearchResultItem.mechShare.push(work.contributors[j].mechanicalShare); }
                                else { workSearchResultItem.mechShare.push(0) }
                                
                            }
                        }

                        if (work.workTerritorySpecificInfo && work.workTerritorySpecificInfo.length > 0 && work.workTerritorySpecificInfo[0].workStatus != null && workSearchResultItem.status == null) {
                            // If anything except 'DRAFT' is present, display 'Draft Submitted', if 'Draft' is present then display 'Draft'
                            workSearchResultItem.status = work.workTerritorySpecificInfo[0].workStatus == "DRAFT" ? 'Draft' : 'Draft Submitted';
                        }

                        // Incase invalid work and no WorkTerritorySpecificInfo is present 
                        if (workSearchResultItem.status == null) {
                            workSearchResultItem.status = 'Draft';
                        }

                        draftWorkSearchResultItems.push(workSearchResultItem);

                    }

                    resolve(draftWorkSearchResultItems);
                })
                .catch(response => {
                    reject(response.message);
                })
        });
    }

    public static getDraftWork(dataSource: string, DraftWorkId: number, includeAllMyAccounts?: boolean): Promise<any> {
        return new Promise<any>((resolve, reject) => {
			const includeAllValue = (includeAllMyAccounts ? 'true' : 'false');
            axiosInstance
                .get("/MembersPortalWork/" + dataSource + '/'+ includeAllValue + '/' + DraftWorkId)
                .then(response => {
                    if (response.status === 200) {
                        const result = response.data;
                        resolve(result);
                    }
                    else {
                        throw response;
                    }
                })
                .catch(err => {
                    reject(err);
                })
        })
    }

    public static getDraftAgreement(dataSource: string, DraftAgreementId: number): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            axiosInstance
                .get("/MembersPortalAgreement/" + dataSource + '/' + DraftAgreementId)
                    .then(response => {
                        if (response.status === 200) {
                            const result = response.data;
                            let IPNameNumbers: string[] = [];
                            for (let i = 0; i < result.agreementAdminIP.length; i++) {
                                IPNameNumbers.push(result.agreementAdminIP[i].administeredIP?.toString());
                            }
                            const generateRequestBodyList = (ipNameNumbers) => {
                                return ipNameNumbers.filter(ipNameNumber => ipNameNumber != null && ipNameNumber !== '' && isValidNumber(ipNameNumber.toString())).map(ipNameNumber => ({
                                    ipiNumber: {
                                        value: ipNameNumber,
                                        type: 0
                                    },
                                    fullName: {
                                        value: '',
                                        type: 0
                                    },
                                    ipBaseNumber: {
                                        value: '',
                                        type: 0
                                    },
                                    accountNumber: {
                                        value: '',
                                        type: 1
                                    },
                                    interestedPartyType: '',
                                    replacedAccounts: [],
                                    pagination: {
                                        count: 10,
                                        skip: 0
                                    }
                                }));
                            };
                            const agreementIPListHead = generateRequestBodyList([result.ipNameNumber]);
                            let agreementIPs = generateRequestBodyList(IPNameNumbers);
                            agreementIPs = agreementIPListHead.concat(agreementIPs);
                            axiosInstance
                                .post("/Search/DraftAgreementAssignees", agreementIPs)
                                .then(response => {
                                    const responseHead = response.data[0];
                                    result.societyAffiliation = responseHead.societyAffiliation;
                                    response.data.shift();
                                    for (let i = 0; i < response.data.length; i++) {
                                        result.agreementAdminIP[i].societyAffiliation = response.data[i].societyAffiliation;
                                    }
                                    resolve(result);
                                })
                                .catch(err => {
                                    reject(err);
                                });
                        }
                        else {
                            throw response;
                        }
                    })
                    .catch(err => {
                        reject(err);
                    })
        })
    }

    public static getGetProductDetails(dataSource: string, ProductCoreId: number): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            axiosInstance
                .get("/MembersPortalSetList/" + dataSource + '/' + ProductCoreId)
                .then(response => {
                    if (response.status === 200) {
                        const result = response.data;
                        resolve(result);
                    }
                    else {
                        throw response;
                    }
                })
                .catch(err => {
                    reject(err);
                })
        })
    }

    public static getLivePerformance(usageId): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            axiosInstance
                .get("/MembersPortalLivePerformance/" + usageId)
                .then(response => {
                    if (response.status === 200) {
                        resolve(response.data);
                    }
                    else {
                        throw response;
                    }
                })
                .catch(err => {
                    reject(err)
                })
        })
    }

    public static getRegisteredWorkHistoryVersion(registeredWorkID: number, versionNumber: number): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            axiosInstance
                .get("/RegisteredWork/RegisteredWorkHistory/" + registeredWorkID + '/' + versionNumber)
                .then(response => {
                    if (response.status === 200) {
                        const result = response.data;
                        resolve(result);
                    }
                    else {
                        throw response;
                    }
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    public static getRegisteredWorks(searchQuery: IRegisteredWorkSearchQuery): Promise<IRegisteredWorkSearchResult[]> {
        const {
            title,
            status,
            workNumber,
            artist,
            ipNumber,
            ipName,
            dataSource,
            currentUserNameNumber,
            contributor,
            fromRegistrationDate,
            toRegistrationDate,
            includeMyWorksRegisteredViaOtherChannels,
			includeMyWorksRegisteredAllMyAccounts,
            selectedAgreementIDs
        } = searchQuery;
        return new Promise<IRegisteredWorkSearchResult[]>((resolve, reject) => {
            const contributorOrEmptyString = contributor ? contributor : '';
            axiosInstance
                .post("/Search/RegisteredWorks", {
                    title: title,
                    status: status,
                    workNumber: workNumber,
                    artist: artist,
                    ipNumber: ipNumber,
                    ipName: ipName,
                    dataSource: dataSource,
                    currentUserNameNumber: currentUserNameNumber,
                    contributor: contributorOrEmptyString,
                    fromRegistrationDate: fromRegistrationDate,
                    toRegistrationDate: toRegistrationDate,
                    includeMyWorksRegisteredViaOtherChannels: includeMyWorksRegisteredViaOtherChannels ? true : false,
                    includeMyWorksRegisteredAllMyAccounts: includeMyWorksRegisteredAllMyAccounts ? true : false,
                    selectedAgreementIDs: selectedAgreementIDs
                })
                .then(response => {
                    const registeredWorkSearchResultItems: IRegisteredWorkSearchResult[] = [];
                    for (let x = 0; x < response.data.length; x++) {
                        const work = response.data[x];
                        const workCode = response.data[x].workTerritorySpecificInfo?.[0]?.workStatus ?? "-";

                        let workSearchResultItem: IRegisteredWorkSearchResult = {
                            workID: response.data[x].workID,
                            dataSource: response.data[x].dataSource,
                            title: [],
                            status: workCode,
                            workNumber: [],
                            workContributorIDs: [],
                            contributors: [],
                            ipNumber: [],
                            role: [],
                            perfShare: [],
                            mechShare: [],
                            performers: [],
                            dateOfRegistration: response.data[x].dateOfRegistration,
                            duration: response.data[x].duration
                        }

                        for (let j = 0; j < 3; j++) {
                            if (work.workNames[j]) {
                                workSearchResultItem.title.push(work.workNames[j].name);
                            }

                            if (work.workNumbers[j]) {
                                workSearchResultItem.workNumber.push(work.workNumbers[j].number);
                            }

                            if (work.performers[j]) {
                                workSearchResultItem.performers.push(work.performers[j].fullName);
                            }
                        }

                        if (work.contributors) {
                            for (let j = 0; j < work.contributors.length; j++) {
                                if (work.contributors[j].workContributorID != null) { workSearchResultItem.workContributorIDs.push(work.contributors[j].workContributorID); }
                                else { workSearchResultItem.workContributorIDs.push(0); }

                                if (work.contributors[j].fullName != null && work.contributors[j].fullName != ' ') { workSearchResultItem.contributors.push(work.contributors[j].fullName); }
                                else { workSearchResultItem.contributors.push('unknown'); }

                                if (work.contributors[j].type != null) { workSearchResultItem.role.push(work.contributors[j].type); }
                                else { workSearchResultItem.role.push('X'); }

                                if (work.contributors[j].ipiNumber != null) { workSearchResultItem.ipNumber.push(work.contributors[j].ipiNumber); }
                                else { workSearchResultItem.ipNumber.push(0) }

                                if (work.contributors[j].performingShare != null) { workSearchResultItem.perfShare.push(work.contributors[j].performingShare); }
                                else workSearchResultItem.perfShare.push(0);

                                if (work.contributors[j].mechanicalShare != null) { workSearchResultItem.mechShare.push(work.contributors[j].mechanicalShare); }
                                else { workSearchResultItem.mechShare.push(0) }
                            }
                        }
                        registeredWorkSearchResultItems.push(workSearchResultItem);

                    }

                    resolve(registeredWorkSearchResultItems);
                })
                .catch(response => {
                    reject(response.message);
                })
        });
    }


    public static getAllRegisteredWorks(searchQuery: IAllRegisteredWorkSearchQuery): Promise<IAllRegisteredWorkSearchResult[]> {
        const {
            title,
            status,
            workNumber,
            artist,
            ipNumber,
            ipName,
            dataSource,
            currentUserNameNumber,
            fromRegistrationDate,
            toRegistrationDate
        } = searchQuery;
        return new Promise<IRegisteredWorkSearchResult[]>((resolve, reject) => {
            axiosInstance
                .post("/Search/AllRegisteredWorks", {
                    title: title,
                    status: status,
                    workNumber: workNumber,
                    artist: artist,
                    ipNumber: ipNumber,
                    ipName: ipName,
                    dataSource: dataSource,
                    currentUserNameNumber: currentUserNameNumber,
                    fromRegistrationDate: fromRegistrationDate,
                    toRegistrationDate: toRegistrationDate
                })
                .then(response => {
                    const workSearchResultItems: IAllRegisteredWorkSearchResult[] = [];
                    for (let x = 0; x < response.data.length; x++) {
                        const work = response.data[x];
                        const workCode = response.data[x].workTerritorySpecificInfo?.[0]?.workStatus ?? "-";

                        let workSearchResultItem: IAllRegisteredWorkSearchResult = {
                            workID: response.data[x].workID,
                            dataSource: response.data[x].dataSource,
                            title: [],
                            status: workCode,
                            workNumber: [],
                            workContributorIDs: [],
                            contributors: [],
                            ipNumber: [],
                            role: [],
                            perfShare: [],
                            mechShare: [],
                            performers: [],
                            dateOfRegistration: response.data[x].dateOfRegistration,
                            duration: response.data[x].duration
                        }

                        for (let j = 0; j < 3; j++) {
                            if (work.workNames[j]) {
                                workSearchResultItem.title.push(work.workNames[j].name);
                            }

                            if (work.workNumbers[j]) {
                                workSearchResultItem.workNumber.push(work.workNumbers[j].number);
                            }

                            if (work.performers[j]) {
                                workSearchResultItem.performers.push(work.performers[j].fullName);
                            }
                        }

                        if (work.contributors) {
                            for (let j = 0; j < work.contributors.length; j++) {
                                if (work.contributors[j].workContributorID != null) { workSearchResultItem.workContributorIDs.push(work.contributors[j].workContributorID); }
                                else { workSearchResultItem.workContributorIDs.push(0); }

                                if (work.contributors[j].fullName != null && work.contributors[j].fullName != ' ') { workSearchResultItem.contributors.push(work.contributors[j].fullName); }
                                else { workSearchResultItem.contributors.push('unknown'); }

                                if (work.contributors[j].type != null) { workSearchResultItem.role.push(work.contributors[j].type); }
                                else { workSearchResultItem.role.push('X'); }

                                if (work.contributors[j].ipiNumber != null) { workSearchResultItem.ipNumber.push(work.contributors[j].ipiNumber); }
                                else { workSearchResultItem.ipNumber.push(0) }

                                if (work.contributors[j].performingShare != null) { workSearchResultItem.perfShare.push(work.contributors[j].performingShare); }
                                else workSearchResultItem.perfShare.push(0);

                                if (work.contributors[j].mechanicalShare != null) { workSearchResultItem.mechShare.push(work.contributors[j].mechanicalShare); }
                                else { workSearchResultItem.mechShare.push(0) }
                            }
                        }
                        workSearchResultItems.push(workSearchResultItem);
                    }
                    resolve(workSearchResultItems);
                })
                .catch(response => {
                    reject(response.message);
                })
        });
    }

    public static getRegisteredWork(dataSource: string, registeredWorkId: number, includeAllMyAccounts?: boolean): Promise<any> {
        return new Promise<any>((resolve, reject) => {
			const includeAllValue = (includeAllMyAccounts ? 'true' : 'false');
            axiosInstance
                .get("/MembersPortalWork/" + dataSource + '/'+ includeAllValue + '/' + registeredWorkId)
                .then(response => {
                    if (response.status === 200) {
                        const result = response.data;
                        resolve(result);
                    }
                    else {
                        throw response;
                    }
                })
                .catch(err => {
                    reject(err);
                })
        })
    }

    public static getArtists(
        artist: IArtistSearchQuery,
        dataSource: string
    ): Promise<IArtist[]> {
        return new Promise<IArtist[]>((resolve, reject) => {
            axiosInstance
                .post("/search/MPartists", {
                    fullName: { value: artist.fullName, type: 0 },
                    firstName: { value: artist.firstName, type: 0 },
                    lastName: { value: artist.lastName, type: 0 },
                    number: { value: artist.number, type: 0 },
                    type: { value: artist.type, type: 0 },
                    dataSource: dataSource
                })
                .then(response => {
                    const artistSearchResultItems: IArtist[] = [];

                    for (let x = 0; x < response.data.length; x++) {
                        const data = response.data[x];

                        const artistSearchResultItem: IArtist = {
                            fullName: data.fullName,
                            performerID: data.performerID,
                            firstName: data.firstName,
                            lastName: data.lastName,
                            type: data.type,
                            number: data.number,
                            workPerformerID: data.workPerformerID,
                            performerNumberID: data.performerNumberID ? data.performerNumberID : 0,
                            numberType: data.numberType,
                        };
                        artistSearchResultItems.push(artistSearchResultItem);
                    }
                    resolve(artistSearchResultItems);
                })
                .catch(res => {
                    reject(res);
                });
        });
    }

    public static getSetListWorks(
        searchQuery: IMatchWorksSearchQuery
    ): Promise<IMatchWorksSearchResult[]> {
        const {
            workIDs,
            title,
            number,
            artist,
            writers,
            societyAccountNumber,
            dataSource,
            workBatchID,
            hasOpenWorkflow
        } = searchQuery;
        return new Promise<IMatchWorksSearchResult[]>((resolve, reject) => {
            axiosInstance
                .post("/search/setListWorks", {
                    workIDs: {
                        values: workIDs.map(id => { return { value: id, type: 2 } })
                    },
                    title: {
                        value: title,
                        type: 0
                    },
                    number: {
                        value: number,
                        type: 0
                    },
                    artist: {
                        value: artist,
                        type: 0
                    },
                    contributor: {
                        value: writers,
                        type: 0
                    },
                    societyAccountNumber: {
                        value: societyAccountNumber,
                        type: 0
                    },
                    workBatchID: {
                        value: workBatchID,
                        type: 2
                    },
                    dataSource: dataSource,
                    hasOpenWorkflow: {
                        value: hasOpenWorkflow,
                        type: 2
                    },
                })
                .then(response => {
                    const workSearchResultItems: IMatchWorksSearchResult[] = [];

                    for (let x = 0; x < response.data.length; x++) {
                        const data = response.data[x];

                        let workSearchResultItem: IMatchWorksSearchResult = {
                            title: [],
                            contributors: [],
                            number: [],
                            writers: [],
                            publishers: [],
                            artists: [],
                            compoundType: data.medleyType ? data.medleyType : '',
                            workID: response.data[x].workID,
                            dataSource: dataSource,
                            duration: data.duration,
                            status: data.status,
                            isDraftSubmitted: data.isDraftSubmitted

                        }

                        for (let x = 0; x < 3; x++) {
                            if (data.workNames[x]) {
                                workSearchResultItem.title.push(data.workNames[x].name)
                            }

                            if (data.workNumbers[x]) {
                                workSearchResultItem.number.push(data.workNumbers[x].number)
                            }

                            if (data.performers[x]) {
                                workSearchResultItem.artists.push(data.performers[x].fullName)
                            }
                        }

                        if (data.contributors) {
                            for (let x = 0; x < data.contributors.length; x++) {
                                if ((data.contributors[x].contributorType === 'Writer' || data.contributors[x].contributorType === 0 ) && workSearchResultItem.writers.length < 3) {
                                    workSearchResultItem.writers.push(data.contributors[x].fullName)
                                }
                                if (data.contributors[x].contributorType === 'Publisher' && workSearchResultItem.publishers.length < 3) {
                                    workSearchResultItem.publishers.push(data.contributors[x].fullName)
                                }
                            }
                        }

                        workSearchResultItems.push(workSearchResultItem);
                    }

                    resolve(workSearchResultItems);
                })
                .catch(res => {
                    reject(res);
                });
        });
    }

    public static getLivePerformances(
        searchQuery: ILivePerformanceSearchQuery
    ): Promise<ILivePerformancesSearchResult> {
        return new Promise<ILivePerformancesSearchResult>((resolve, reject) => {
            axiosInstance
                .post("/search/LivePerformances", {
                    dateFrom: searchQuery.dateFrom,
                    dateTo: searchQuery.dateTo,
                    currentUserNameNumber: searchQuery.currentUserNameNumber
                })
                .then(response => {
                    if (response.status === 200) {
                        const result = response.data;
                        resolve(result);
                    }
                    else {
                        throw response;
                    }
                })
                .catch(err => {
                    reject(err);
                })
        })
    }

    public static getAssigneeAgreements(): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            axiosInstance
                .get("/agreement/AssigneeAgreements")
                .then(response => {
                    if (response.status === 200) {
                        const result = response.data;
                        resolve(result);
                    }
                    else {
                        throw response;
                    }
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    public static getApplicableWorks(
        searchQuery: IApplicableWorkSearchQuery,
    ): Promise<IAgreementWork[]> {
        const {
            workNumber,
            agreementID,
            workName,
            dataSource,
            page,
            pageSize,
            currentUserNameNumber
        } = searchQuery;
        return new Promise<IAgreementWork[]>((resolve, reject) => {
            axiosInstance
                .post("/membersPortalAgreement/ApplicableWorkSearch", {
                    workNumber: workNumber,
                    agreementID: agreementID,
                    workName: workName,
                    dataSource: dataSource,
                    pagination: null,
                    page: page,
                    pageSize: pageSize,
                    currentUserNameNumber: currentUserNameNumber
                })
                .then(response => {
                    const agreementSearchResultItems = [];

                    for (let x = 0; x < response.data.length; x++) {
                        const agreementSearchResultItem = {
                            agreementWorkID: response.data[x].agreementWorkID,
                            workName: response.data[x].workName,
                            workNumber: response.data[x].workNumber,
                            type: (response.data[x].type),
                            workID: response.data[x].workID,
                            agreementID: response.data[x].agreementID,
                            exclusionUntil: response.data[x].exclusionUntil,
                            excludedUntilDate: response.data[x].excludedUntilDate,
                            recipientWorkNumber: response.data[x].recipientWorkNumber,
                            recipientWorkNumberOwner: response.data[x].recipientWorkNumberOwner,
                            useDefaultRetention: response.data[x].useDefaultRetention,
                            worksRetainedUntil: response.data[x].worksRetainedUntil,
                            workRetentionEndDate: response.data[x].workRetentionEndDate,
                            useDefaultCollection: response.data[x].useDefaultCollection,
                            workCollectionUntil: response.data[x].workCollectionUntil,
                            workCollectionEndDate: response.data[x].workCollectionEndDate,
                            isDeleted: response.data[x].isDeleted
                        };

                        agreementSearchResultItems.push(agreementSearchResultItem);
                    }
                    resolve(agreementSearchResultItems);
                })
                .catch(res => {
                    reject(res);
                });
        })
    }
}
